// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"1b28db42","488":"0e5c5c3b","905":"dfc466cc"}[chunkId] + ".chunk.js";
};